import _Api from '@/api/_Api';

import { downloadBlob } from 'download.js';

import b64toBlob from 'b64-to-blob';

import {
   ActivityResponse,
   ActSuppTransfGuidesResponse,
   allActivInMotByUuidParams,
   allActivInMotByUuidResponse,
   CreateReportParams,
} from '@/interfaces/Activities';

/*
import { SuppliersApi } from '@/api/SuppliersApi';
import { SupplierResponse } from '@/interfaces/Suppliers';
*/

export class ActivitiesApi extends _Api {
   static async get(id: number | string): Promise<{ activity: ActivityResponse; o_cost_Current: any; o_cost_New: any }> {
      const response = await this.http().get(`activities/${id}`);
      return response.data;
   }

   static async create(activity: ActivityResponse | any = {}): Promise<{ id: number }> {
      const response = await this.http().post(`activities`, activity);
      return response.data;
   }

   static async update(id: number | string, data: ActivityResponse): Promise<{ id: number }> {
      const response = await this.http().put(`activities/${id}`, data);
      return response.data;
   }

   static async duplicate(id: number | string): Promise<{ activity: ActivityResponse }> {
      const response = await this.http().post(`activities/${id}/duplicate`);
      return response.data;
   }

   static async archive(id: number | string) {
      const response = await this.http().put(`activities/${id}`, { 'change-state': 'archive' });
      return response.data;
   }

   static async unarchive(id: number | string) {
      const response = await this.http().put(`activities/${id}`, { 'change-state': 'unarchive' });
      return response.data;
   }

   static async getActSuppTransfGuidesData(): Promise<ActSuppTransfGuidesResponse> {
      const response = await this.http().get('activities/get-act-supp-transf-guides-data');
      return response.data;
   }

   static async all(params: any = { archive: false }): Promise<any> {
      const response = await this.http().get('activities', { params });
      return response.data;
   }

   /*
   static async suppliers(): Promise<SupplierResponse[]> {
      return SuppliersApi.all();
   }
   */

   static async transfers(params: any): Promise<any> {
      const response = await this.http().get('activities/transfers', { params });
      return response.data;
   }

   static async checkActivityAvailability(params: any): Promise<any> {
      const response = await this.http().post('activities/check-activity-availability', params);
      return response.data;
   }

   static async activityGraphic(params: any): Promise<any> {
      const response = await this.http().post('activities/activity-graphic', params);
      return response.data;
   }

   static async allActivInMotByUuid(params: allActivInMotByUuidParams): Promise<allActivInMotByUuidResponse> {
      const response = await this.http().post('activities/all-activ-in-moto-by-uuid', params);
      return response.data;
   }

   static async acceptActivity(params: any): Promise<any> {
      const response = await this.http().post('activities/accept-activity', params);
      return response.data;
   }

   static async rejectActivity(params: any): Promise<any> {
      const response = await this.http().post('activities/reject-activity', params);
      return response.data;
   }

   static async createReport(params: CreateReportParams): Promise<any> {
      const response = await this.http().post('activities/create-report', params);
      downloadBlob(response.data.filename, b64toBlob(response.data.base64, 'application/pdf'));
   }
}
